export default {
  AKKREDITIERT: "7aa3bdcc-6631-4b9d-8ce2-bd1a4d069fc6",
  AKKREDITIERT_MIT_AUFLAGEN: "34065bcc-d8ef-438e-8318-9293ee817717",
  AKKREDITIERT_AUFLAGEN_ERFUELLT: "5bdcf9cd-a0d4-48f8-b6fd-7e002d900766",
  AKKREDITIERT_AUFLAGEN_TEILW_ERFUELLT: "423cdcf5-e6aa-42b3-ae2f-928b0b126cbf",
  NICHT_AKKREDITIERT: "3aab35f5-7a2f-44cc-a8c9-3e68e18ffea2"
};
